import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { ArticleCover } from "@/components/ArticleCover";

const formatDate = (iso) =>
    new Date(iso + "T12:00:00").toLocaleDateString("pt-BR", { day: "2-digit", month: "long", year: "numeric" });

const FeaturedCard = ({ article, large, index }) => (
    <Link
        to={`/artigo/${article.slug}`}
        data-testid={`featured-article-${index}`}
        className="group relative block overflow-hidden border border-white/10 h-full min-h-[280px]"
    >
        <div className="absolute inset-0 transition-transform duration-700 ease-out group-hover:scale-105">
            <ArticleCover article={article} />
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-[#060913] via-[#060913]/55 to-transparent" />
        <div className="relative h-full flex flex-col justify-end p-6 md:p-8">
            <span className="text-[10px] uppercase tracking-[0.25em] text-gold font-medium mb-3">{article.category}</span>
            <h3 className={`font-serif leading-tight group-hover:text-gold transition-colors ${large ? "text-2xl md:text-4xl" : "text-xl md:text-2xl"}`}>
                {article.title}
            </h3>
            {large && <p className="mt-3 text-sm text-slate-400 clamp-2 max-w-xl">{article.excerpt}</p>}
            <div className="mt-4 flex items-center gap-3 text-[11px] uppercase tracking-wider text-slate-500">
                <span>{formatDate(article.published_at)}</span>
                <span className="w-1 h-1 rounded-full bg-slate-600" />
                <span>{article.read_minutes} min de leitura</span>
                <ArrowUpRight size={14} className="ml-auto text-gold opacity-0 group-hover:opacity-100 transition-opacity" />
            </div>
        </div>
    </Link>
);

export const FeaturedBento = ({ articles }) => {
    if (!articles || articles.length === 0) return null;
    const [first, ...rest] = articles;

    return (
        <section data-testid="featured-section" className="max-w-7xl mx-auto px-4 md:px-8 py-20 md:py-28">
            <Reveal>
                <div className="flex items-end justify-between mb-10 md:mb-14">
                    <div>
                        <span className="text-xs uppercase tracking-[0.3em] text-gold font-medium">Destaques</span>
                        <h2 className="font-serif text-3xl md:text-5xl tracking-tight mt-3">Leituras essenciais</h2>
                    </div>
                    <span className="hidden md:block text-xs uppercase tracking-[0.25em] text-slate-600">Edição — Julho 2026</span>
                </div>
            </Reveal>

            <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8">
                <Reveal className="md:col-span-7" delay={0.1}>
                    <FeaturedCard article={first} large index={0} />
                </Reveal>
                <div className="md:col-span-5 flex flex-col gap-6 md:gap-8">
                    {rest.slice(0, 2).map((a, i) => (
                        <Reveal key={a.slug} delay={0.2 + i * 0.1} className="flex-1">
                            <FeaturedCard article={a} index={i + 1} />
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
};
